import {
  CookieNames,
  LocationSource,
  VALID_LOCATION_SOURCE_SET,
  ValidLocationSource
} from '../constants';
import type { CookieClient, LocationData } from '../types';

const isValidLocationSource = (
  value: string | undefined
): value is ValidLocationSource =>
  value !== undefined && VALID_LOCATION_SOURCE_SET.has(value);

const EXPECTED_COOKIE_COUNT = 4;

export default function getLocationFromCookies(
  cookies: CookieClient
): LocationData | null {
  const sourceValue = cookies.get(CookieNames.Source);

  const location: LocationData = {
    accuracyRadius: undefined,
    city: cookies.get(CookieNames.City) ?? '',
    source: isValidLocationSource(sourceValue)
      ? sourceValue
      : LocationSource.Unknown,
    state: cookies.get(CookieNames.State) ?? '',
    zip: cookies.get(CookieNames.Zip) ?? ''
  };

  const receivedCookieCount = Object.values(location).filter(Boolean).length;

  return receivedCookieCount === EXPECTED_COOKIE_COUNT
    ? { ...location, isFromCookies: true }
    : null;
}
